import { takeLatest, put, throttle } from 'redux-saga/effects'
import { mapActiveMunicipality } from 'components/map/actions'
import { popupActions } from 'components/popup/actions'

/**
 * Depending on the active municipality ID, we show the Popup (or we don't)
 *
 * This is obviously a bit of a special case, in a more general case we
 * would use some other trigger
 * @param activeMunicipality
 */
function* updateVisibilityOfPopup({ payload: activeMunicipality }) {
  if (activeMunicipality < 0) {
    yield put(popupActions.popup.hide())
  } else {
    yield put(popupActions.popup.show())

    // Get the municipality element that matches this ID
    const element = window.document.getElementById(
      'map-1-gem-el-' + activeMunicipality
    )
    yield put(popupActions.popup.position.takeFrom(element))
  }
}

function* updatePopupLocation({ payload: annotatedElement }) {
  let bounds = annotatedElement.getBoundingClientRect()
  yield put(
    popupActions.popup.position.set(
      // use window.page<direction>Offset, otherwise InternetExplorer screws up
      bounds.top + window.pageYOffset,
      bounds.left + window.pageXOffset
    )
  )
}

export function* watchActiveMunicipality() {
  yield takeLatest(mapActiveMunicipality, updateVisibilityOfPopup)
}

export function* watchAnnotatedElement() {
  yield throttle(333, 'POPUP/POSITION/TAKE_FROM', updatePopupLocation)
}
